import { style } from "@vanilla-extract/css";

import { transition } from "../../utils/transition";

export const positionerStyle = style({
  zIndex: 2,
});

export const displayStyle = style({
  userSelect: "none",
  transition: transition("color"),
});

export const defaultInputStyle = style({
  width: "100%",
});
